import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer" data-testid="footer">
      <div className="container">
        <div className="footer-content">
          <div className="grid grid-4 gap-lg">

            {/* Logo & Description */}
            <div className="footer-section">
              <Link to="/" className="footer-logo">
                <img
                  src="https://customer-assets.emergentagent.com/job_profinance/artifacts/2497se8c_Intlrr%20-%20White%20%28.png%29.png"
                  alt="Intlrr"
                  className="footer-logo-img"
                />
              </Link>

              <p className="footer-description">
                Empowering the next generation of finance professionals through
                hands-on learning and industry mentorship.
              </p>

              <div className="social-links">
                <a href="#" className="social-link">LinkedIn</a>
                <a href="#" className="social-link">Twitter</a>
                <a href="#" className="social-link">Instagram</a>
              </div>
            </div>

            {/* Programs */}
            <div className="footer-section">
              <h4 className="footer-title">Programs</h4>
              <ul className="footer-links">
                <li>
                  <Link to="/programs/equity-research">
                    Equity Research & Financial Modeling
                  </Link>
                </li>
                <li>
                  <Link to="/programs/fixed-income">
                    Fixed Income & Credit Analysis
                  </Link>
                </li>
                <li>
                  <Link to="/programs/quantitative-finance">
                    Quantitative Finance
                  </Link>
                </li>
              </ul>
            </div>

            {/* Company */}
            <div className="footer-section">
              <h4 className="footer-title">Company</h4>
              <ul className="footer-links">
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/mentorship">Mentorship</Link></li>
                <li><Link to="/placement">Placement Support</Link></li>
                <li><Link to="/resources">Resources</Link></li>
                <li>
  <a href="/verify">Verify Certificate</a>
</li>
              </ul>
            </div>

            {/* Contact */}
            <div className="footer-section">
              <h4 className="footer-title">Contact</h4>
              <ul className="footer-links">
                <li><Link to="/contact">Get in Touch</Link></li>
                <li>
                  <a href="mailto:support@intlrr.com">
                    support@intlrr.com
                  </a>
                </li>
              </ul>
            </div>

          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>© 2026 Intlrr. All rights reserved.</p>

            <div className="footer-legal">
              <Link to="/privacy-policy">Privacy Policy</Link>
              <Link to="/cancellation-refund">Cancellation & Refund</Link>
              <Link to="/shipping-delivery">Shipping & Delivery</Link>
              <Link to="/terms">Terms of Service</Link>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .footer {
          background: var(--primary);
          color: white;
          margin-top: auto;
        }

        .footer-content {
          padding: var(--space-3xl) 0 var(--space-xl);
        }

        .footer-logo-img {
          height: 90px;
          margin-bottom: var(--space-md);
        }

        .footer-description {
          color: rgba(255, 255, 255, 0.8);
          margin-bottom: var(--space-lg);
          line-height: 1.6;
        }

        .footer-title {
          font-size: 1.1rem;
          font-weight: 600;
          margin-bottom: var(--space-md);
        }

        .footer-links {
          list-style: none;
          padding: 0;
        }

        .footer-links li {
          margin-bottom: var(--space-sm);
        }

        .footer-links a {
          color: rgba(255, 255, 255, 0.8);
          text-decoration: none;
        }

        .footer-links a:hover {
          color: var(--secondary);
        }

        .social-links {
          display: flex;
          gap: var(--space-md);
        }

        .social-link {
          color: rgba(255, 255, 255, 0.8);
          text-decoration: none;
          font-weight: 500;
        }

        .social-link:hover {
          color: var(--secondary);
        }

        .footer-bottom {
          border-top: 1px solid rgba(255, 255, 255, 0.15);
          padding: var(--space-lg) 0;
        }

        .footer-bottom-content {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: var(--space-md);
          color: rgba(255, 255, 255, 0.8);
        }

        .footer-legal {
          display: flex;
          gap: var(--space-lg);
          flex-wrap: wrap;
        }

        .footer-legal a {
          color: rgba(255, 255, 255, 0.8);
          text-decoration: none;
        }

        .footer-legal a:hover {
          color: var(--secondary);
        }

        @media (max-width: 768px) {
          .footer-content .grid {
            grid-template-columns: repeat(2, 1fr);
          }

          .footer-bottom-content {
            flex-direction: column;
            text-align: center;
          }
        }

        @media (max-width: 480px) {
          .footer-content .grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;
